import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [notificationCount] = useState(3);

  const navigationItems = [
    // { 
    //   label: 'Dashboard', 
    //   path: '/offer-tracking-dashboard',
    //   icon: 'BarChart3'
    // },
    // { 
    //   label: 'Sell Vehicle', 
    //   path: '/vehicle-information-upload',
    //   icon: 'Car'
    // },
    // { 
    //   label: 'My Offers', 
    //   path: '/offer-review-acceptance',
    //   icon: 'FileText'
    // },
    // { 
    //   label: 'Schedule', 
    //   path: '/vehicle-inspection-scheduling',
    //   icon: 'Calendar'
    // },
    // { 
    //   label: 'Account', 
    //   path: '/transaction-history-profile',
    //   icon: 'User'
    // }
  ];

  const isActivePath = (path) => location.pathname === path;

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleUserMenuToggle = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const handleLogout = () => {
    // Handle logout logic
    setIsUserMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-100 bg-card border-b border-border shadow-soft">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-16 px-4 lg:px-6">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center cursor-pointer" onClick={() => navigate('/')}>
                <Icon name="Car" size={20} color="white" />
              </div>
              <span className="text-xl font-bold text-foreground">CarSellFast</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            {navigationItems.map((item) => (
              <button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                className={`
                  flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-smooth
                  ${isActivePath(item.path)
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                  }
                `}
              >
                <Icon name={item.icon} size={16} />
                <span>{item.label}</span>
                {item.path === '/offer-tracking-dashboard' && notificationCount > 0 && (
                  <span className="bg-accent text-accent-foreground text-xs rounded-full px-2 py-0.5 min-w-[20px] text-center">
                    {notificationCount}
                  </span>
                )}
              </button>
            ))}
          </nav>

          {/* User Menu & Mobile Menu */}
          {/* <div className="flex items-center space-x-4">
            
            <button className="relative p-2 text-muted-foreground hover:text-foreground transition-smooth">
              <Icon name="Bell" size={20} />
              {notificationCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-accent text-accent-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {notificationCount}
                </span>
              )}
            </button>

           
            <div className="relative">
              <button
                onClick={handleUserMenuToggle}
                className="flex items-center space-x-2 p-2 rounded-lg hover:bg-muted transition-smooth"
              >
                <div className="w-8 h-8 bg-secondary rounded-full flex items-center justify-center">
                  <Icon name="User" size={16} color="white" />
                </div>
                <span className="hidden lg:block text-sm font-medium text-foreground">John Doe</span>
                <Icon name="ChevronDown" size={16} className="text-muted-foreground" />
              </button>

              {isUserMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-popover border border-border rounded-lg shadow-elevated z-200">
                  <div className="py-1">
                    <button
                      onClick={() => {
                        handleNavigation('/transaction-history-profile');
                        setIsUserMenuOpen(false);
                      }}
                      className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-smooth"
                    >
                      <Icon name="User" size={16} />
                      <span>Profile</span>
                    </button>
                    <button
                      onClick={() => {
                        setIsUserMenuOpen(false);
                      }}
                      className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-smooth"
                    >
                      <Icon name="Settings" size={16} />
                      <span>Settings</span>
                    </button>
                    <hr className="my-1 border-border" />
                    <button
                      onClick={handleLogout}
                      className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-destructive hover:bg-muted transition-smooth"
                    >
                      <Icon name="LogOut" size={16} />
                      <span>Sign out</span>
                    </button>
                  </div>
                </div>
              )}
            </div>

 
            <button className="md:hidden p-2 text-muted-foreground hover:text-foreground transition-smooth">
              <Icon name="Menu" size={20} />
            </button>
          </div> */}
        </div>

        {/* Mobile Navigation */}
        <nav className="md:hidden border-t border-border bg-card">
          <div className="flex overflow-x-auto">
            {navigationItems.map((item) => (
              <button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                className={`
                  flex flex-col items-center space-y-1 px-4 py-3 min-w-[80px] text-xs font-medium transition-smooth
                  ${isActivePath(item.path)
                    ? 'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
                  }
                `}
              >
                <div className="relative">
                  <Icon name={item.icon} size={20} />
                  {item.path === '/offer-tracking-dashboard' && notificationCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-accent text-accent-foreground text-xs rounded-full w-4 h-4 flex items-center justify-center">
                      {notificationCount}
                    </span>
                  )}
                </div>
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;